import React, { forwardRef } from 'react';
import {
  FDStack, FDCallToActionButton, FDEmphasisSurface,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const InsightCTASection = forwardRef(({ handleSubmit }, ref) => {
  const isMobile = useMobileLayout();
  const {
    resource, saving,
  } = useMetaLayoutContext();

  return (
    <div ref={ref}>
      <FDStack maxWidth={720}>
        <FDEmphasisSurface appearance={'flat'} color={'info'}>
          <FDStack padding={isMobile ? 2 : 4} direction={'column'} spacing={2}>
            <MetaControlField attr={'contactInfoTitle'} />
            <MetaControlField attr={'contactFormDescription'} />
            <FDStack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'center'}>
              <FDCallToActionButton onClick={handleSubmit} label={resource.attr('primaryActionLabel')} isFullWidth={isMobile} size={'lg'} disabled={saving} {...dataAttrs('get-started-btn')} />
            </FDStack>
          </FDStack>
        </FDEmphasisSurface>
      </FDStack>
    </div>
  );
});
